<template>
  <button type="button" :class="[toggled ? 'selected' : '', 'station-schedule-toggle-button', 'btn', 'btn-block', 'btn-lg']" @click.prevent="onClicked">
    <div class="station-schedule-toggle-checkbox"><i :class="['far', toggled ? 'fa-check-square' : 'fa-square']" /></div><slot />
    <div class="station-schedule-filter-badge" v-if="badge > 0">{{badge}}</div>
  </button>
</template>

<style scoped>
.station-schedule-toggle-button {
  position: relative;
  font-size: 1rem;
  line-height: 1rem;
  background-color: #56C473;
  color: #0b441b;
  height: 46px;
}
.station-schedule-toggle-checkbox {
  position: absolute;
  left: 10px;
}
.station-schedule-filter-badge {
  position: absolute;
  top: 4px;
  right: 4px;
  min-width: 24px;
  height: 24px;
  border-radius: 10px;
  background-color: #0b441b;
  color: #adeca3;
  font-size: 0.85rem;
  padding: 0 4px 0 4px;
  text-align: center;
  line-height: 24px;
  vertical-align: middle;
  font-weight: 500;
}
</style>

<script>
export default {
  name: 'StationFilterButton',
  model: {
    event: 'change'
  },
  props: {
    value: Boolean,
    badge: Number
  },
  data() {
    return {
      toggled: this.$props.value ? true : false
    }
  },
  watch: {
    value: function(newVal) {
      this.toggled = this.$props.value ? true : false
    }
  },
  methods: {
    onClicked() {
      this.toggled = !this.toggled
      this.$emit('change', this.toggled)
    }
  }

}
</script>